import { Auth } from "../store/authorize";

/**
 * Module-level live auth state — the single source of truth that the axios interceptors and the SignalR hub read
 * imperatively (outside React). It is kept in lock-step with Redux + storage by authState's applyAuth/clearAuth, so
 * interceptors never depend on a stale React closure. Subscribe to mirror changes back into React if needed.
 */
type Listener = (auth: Auth | null) => void;

let current: Auth | null = null;
const listeners = new Set<Listener>();

export const authStore = {
  get(): Auth | null {
    return current;
  },
  set(auth: Auth | null): void {
    current = auth;
    listeners.forEach((l) => l(auth));
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
